module.exports = __webpack_public_path__ + "img/fi-rr-cursor-text.bc1dfb51.svg";